<template>
  <div class="disease-risk">
    <!-- <h4 class="title">统计数据</h4> -->
    <!--3倍大的 canvas， 需缩小3倍-->
    <canvas class="gk-chart" ref="meterChart" width="600" height="450"></canvas>

    <div class="info">
      <ul v-if="gdb3">
        <li>{{ child === 1 ? '孩子' : '您' }}可能的终生患病风险: <span class="s1">{{ data.risk_of_illness }}%</span></li>
        <li>中国人平均终生患病风险: <span class="s3">{{ data.risk_of_illness_chinese }}%</span></li>
        <li>{{ child === 1 ? '孩子' : '您' }}患病风险为中国人平均值的: <span class="s2">{{ data.risk_level }}</span>倍</li>
      </ul>
      <ul v-if="gdb2">
        <li>终生患病风险: <span class="s1">{{ data.rate }}%</span></li>
        <li>患病风险倍数: <span class="s2">{{ data.risk }}</span>倍</li>
        <li>中国人终生患病风险: <span class="s3">{{ data.lifetime }}%</span></li>
      </ul>
    </div>

    <canvas class="gk-chart" ref="pieChart1" width="600" height="450"></canvas>

    <div class="info2">
      <ul v-if="gdb3">
        <li class="yellow">
          <i class="rect"></i> 终生患病概率跟{{ child === 1 ? '孩子' : '您' }}相同的人群占: {{ data.equal_percentage }}%
        </li>
        <li class="red">
          <i class="rect"></i> 终生患病风险概率高于{{ child === 1 ? '孩子' : '您' }}的人群占: {{ data.high_percentage }}%
        </li>
        <li class="blue">
          <i class="rect"></i> 终生患病概率比{{ child === 1 ? '孩子' : '您' }}低的人群占: {{ data.low_percentage }}%
        </li>
      </ul>
      <ul v-if="gdb2">
        <li class="red">
          <i class="rect"></i> 患病率高于您的人群占比: {{ data.up_rate }}%
        </li>
        <li class="yellow">
          <i class="rect"></i> 患病率与您相同的人群占比: {{ data.same_rate }}%
        </li>
        <li class="blue">
          <i class="rect"></i> 患病率低于您的人群占比: {{ data.low_rate }}%
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data', 'risk'],
  data: function () {
    return {
      main:'',
      max:'',
      child: this.util.getLS(this.api.child), // 是否是儿童版报告
      gdb3: false,
      gdb2: false,
      multiple: 3 ,// 3倍缩放， 使 canvas 更清晰
    }
  },
  created(){
    console.log(this)
  },
  methods: {
    getChartColor () {
      let risk = this.risk//根据风险评估判断颜色
      if (risk === 1) {
        return '#00A8DF'//蓝色
      } else if (risk === 3) {
        return '#76CC16'//绿色
      } else {
        return '#F84A2A'//红色
      }
    },
    drawMeterChart () {
      let meterChart = this.$refs.meterChart
      let ctx = meterChart.getContext('2d')
      let riskStart = this.riskStart + ''
      let riskEnd = this.riskEnd + ''
      let currentRisk = this.currentRisk + ''
      // let middleRisk = (((parseFloat(this.max)-parseFloat(this.main))/2)+parseFloat(this.main)).toFixed(1)
      let multiple = this.multiple//放大倍数
      let cx = 100 * multiple // 表盘的中心x （也是绿色圈的中心）
      let cy = 115 * multiple // 表盘的中心y （也是绿色圈的中心）
      let cr1 = 70 * multiple // 表盘的半径
      let cr = 24 * multiple // 绿色圈半径
      let color = this.getChartColor()//中间圆圈颜色
      /*文字(包括左右和中间圆形中文字)上下左右居中 */
      ctx.font = (14 * multiple) + 'px Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillStyle = '#F84A2A';
      /*环形最大值与最小值,被注释的是指针的值*/
      ctx.fillText(riskStart, cx - cr1, 140 * multiple)
      ctx.fillText(riskEnd, cx + cr1, 140 * multiple)
      // ctx.fillText(middleRisk, cx, 30 * multiple)
      ctx.fillStyle = color//圆形颜色
      /**指针配置 */
      ctx.beginPath()
      ctx.arc(cx, cy, cr, 0, 2 * Math.PI)
      ctx.fill()
      ctx.fillStyle = '#fff'//圆形文字颜色
      ctx.fillText(currentRisk, cx, cy)

      // 弧形渐变表盘
      ctx.beginPath()
      let gradient = ctx.createLinearGradient(0, 0, 200 * multiple, 0)
      gradient.addColorStop('0', '#00A8DF')
      gradient.addColorStop('0.5', '#76CC16')
      gradient.addColorStop('1.0', '#F84A2A')
      // 用渐变进行填充
      ctx.strokeStyle = gradient
      ctx.lineWidth = 4 * multiple
      ctx.arc(cx, cy, cr1, 1*Math.PI,0,false)
      ctx.stroke()

      // 表针
      ctx.beginPath()
      ctx.strokeStyle = color
      let deg = 0
    if(this.data.risk_level===this.data.min_risk_level&&this.data.min_risk_level!==this.data.max_risk_level){//指针指向开始值
      // ctx.beginPath()
      ctx.lineWidth = 2 * multiple
      ctx.moveTo(cx-cr, cy)//圆心值
      ctx.lineTo(cx-cr1, cy)
      ctx.stroke()
    }else if(this.data.risk_level===this.data.max_risk_level&&this.data.min_risk_level!==this.data.max_risk_level){//指针指向结束值
      // ctx.beginPath()
      ctx.lineWidth = 2 * multiple
      ctx.moveTo(cx+cr, cy)//圆心值
      ctx.lineTo(cx+cr1, cy)
      ctx.stroke()
    }else if(this.data.risk_level===this.data.min_risk_level&&this.data.min_risk_level===this.data.max_risk_level){//三值相同时候无指针
    }else{
     if (this.currentRisk < 1) {
        deg = (this.currentRisk - this.riskStart) / (1 - this.riskStart) * Math.PI / 2
      } else if(this.currentRisk == 1){
        deg = (this.currentRisk - this.data.min_risk_level) / (this.data.max_risk_level- this.data.min_risk_level) * Math.PI
      }else {
        deg = (this.currentRisk - 1) / (this.riskEnd - 1) * Math.PI / 2 + Math.PI / 2
      }
     
      // console.log(deg)
      let RealDeg = Math.PI - deg
      let width = cr1 - 5 * multiple
      let x = cx + Math.cos(RealDeg) * width
      let y = cy - Math.sin(RealDeg) * width
      // console.log(x, y) // 针尖的x, y

      let x1 = cx + (cr + 5) * (x - cx) / width
      let y1 = cy - (cr + 5 * multiple) * (cy - y) / width
      // console.log(x1, y1)

      // ctx.beginPath()
      ctx.lineWidth = 2 * multiple
      ctx.moveTo(x, y)//圆心值
      ctx.lineTo(x1, y1)
      ctx.stroke()
    }
    },
    drawPieChart1 () {
      let multiple = this.multiple
      let pieChart1 = this.$refs.pieChart1
      let ctx = pieChart1.getContext('2d')
      let cx = pieChart1.width / 2
      let cy = pieChart1.height / 2
      let cr = 70 * multiple
      let sicknessRate = this.sicknessRate
      console.log(cx, cy)
      let startDeg = 0 // 存放每次的起始角度
      let color = ['#FA564D', '#FEB500', '#00C0EE']
      ctx.font = (14 * multiple) + 'px Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      let endDegs = []
      for (let i = 0, len = sicknessRate.length; i < len; i++) {
        ctx.fillStyle = color[i]
        let endDeg = sicknessRate[i] / 100 * 2 * Math.PI
        endDegs.push(endDeg)
        console.log('startDeg: ', startDeg)
        console.log('endDeg: ', startDeg + endDeg)
        ctx.beginPath()
        ctx.moveTo(cx, cy)
        ctx.arc(cx, cy, cr, startDeg, startDeg + endDeg, false)
        ctx.fill()
        startDeg = startDeg + endDeg
      }
    },
    clear () {
      let meterChart = this.$refs.meterChart
      let ctx = meterChart.getContext('2d')
      ctx.clearRect(0, 0, 600, 450)//给定矩形内清空样式
      let pieChart1 = this.$refs.pieChart1
      let ctx1 = pieChart1.getContext('2d')
      ctx1.beginPath()
      ctx1.clearRect(0, 0, 600, 450)
    }
  },
  computed: {
    riskStart () {
      if (this.gdb3) {
        this.main = this.data.min_risk_level
        return this.data.min_risk_level = this.data.min_risk_level 
      } else {
        return this.data.min_risk >= 1 ? 0 : this.data.min_risk
      }
    },
    riskEnd () {
      if (this.gdb3) {
        this.max = this.data.max_risk_level
        return this.data.max_risk_level = this.data.max_risk_level
      } else {
        return this.data.max_risk <= 1 ? this.data.max_risk + 1 : this.data.max_risk
      }
    },
    currentRisk () {
      if (this.gdb3) {
        return this.data.risk_level
      } else {
        return this.data.risk
      }
    },
    sicknessRate () {
      if (this.gdb3) {
        return [this.data.high_percentage, this.data.equal_percentage, this.data.low_percentage] // 顺序是 高 相同 低
      } else {
        return [this.data.up_rate, this.data.same_rate, this.data.low_rate] // 顺序是 高 相同 低
      }
    }
  },
  watch: {
    data: function () {
      this.clear()
      this.drawMeterChart()
      this.drawPieChart1()
    }
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
    } else {
      this.gdb2 = true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/functions";
  .disease-risk {
    color: #000;
    .title {
      padding-left: pxToRem(40px);
      padding-top: pxToRem(26px);
      color: #AAA9AA;
      font-weight: normal;
    }
    .info {
      padding: 2em 0 2em pxToRem(120px);
      .s1, .s2, .s3 {
        font-size: 1.2em;
      }
      .s1 {
        color: #FB7376;
      }
      .s2 {
        color: #7C70B9;
      }
      .s3 {
        color: #0090AF;
      }
    }
    .info2 {
      padding: 2em 0 2em pxToRem(100px);
      .red {
        .rect {
          background: #FB7376;
        }
      }
      .yellow {
        color: #FEB500;
        .rect {
          background: #FEB500;
        }
      }
      .blue {
        .rect {
          background-color: #00C0EE;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DiseaseRisk.vue